/* eslint-disable @typescript-eslint/camelcase */

// import Address from './Address';

export default class Client {
  id = 0;

  first_name = '';

  last_name = '';

  email = '';

  accepted_customer_terms_at = '';

  accepted_upper_hand_terms_at = '';

  active_membership_color = '';

  active_membership_id = 0;

  active_membership_name = '';

  // address: Address;
  age = 0;

  // availability_schedule_id: AvailabilityScheduleID;
  date_of_birth = '';

  gender = '';

  get_email_notifications = false;

  invite_sent_at = '';

  last_login_at = '';

  login_enabled = false;

  managed_by_id = 0;

  managing_customer_user_id = 0;

  managing_customer_user_name = '';

  is_new_user = false;

  phone = '';

  profile_image: { url: string } = { url: '' };

  has_purchases = false;

  time_zone = '';

  time_zone_name = '';

  time_zone_offset = '';

  type = '';

  user_id = 0;

  uuid = '';

  note = '';

  created_at = '';

  updated_at = '';

  archived_at = '';

  archived = false;
}
